import React, { useEffect } from 'react';
import { useFormik } from 'formik';

import { Grid } from '@mui/material';
import { postDataToTheServer } from '../../../../helpers/api';
import AppURL from '../../../../constants/AppURL';
import { ToastSuccess, ToastWarning } from '../../../../constants/Toast';
import Container from '../../../../constants/Container';
import SecHeading from '../../../../constants/SecHeading';
import InputTextBox from '../../../../constants/InputTextBox';
import NepaliInputBox from '../../../../constants/NepaliInputBox';
import { handleNepaliInputChange, handleSelectBox } from '../../../../helpers/handleChange';
import { EndBaseLine } from '../../../../constants/AppSpace';
import { Button } from '../../../../constants/Button';
import SelectInputBox from '../../../../constants/SelectInputBox';
import { EmployeeOptions, NepaliMonthOptions, YesNoOptions } from '../../../../constants/Options';
import { NepNowDateFormat, NowNepaliYearName } from '../../../../constants/DateFormat';
import { EmployeeSalary } from '../../../../helpers/models/Models';
import useFetchSubData from '../../../../helpers/useSubFetch';
import { useDispatch } from 'react-redux';
import { STAFF_PAYROLL_LIST } from '../../../../store/payrollSlice';


interface EmployeeAddFormViewProps {
    handleFormSuccess: () => void;
    data: {
        data: EmployeeSalary[];
    }
}
const PayrollCreateFormView: React.FC<EmployeeAddFormViewProps> = ({ data, handleFormSuccess }) => {
    const employeeOptions = EmployeeOptions(data?.data);
    const dispatch = useDispatch();
    const dateNep = NepNowDateFormat();
    const YearName = NowNepaliYearName();
    const initialValues = {
        sn: "",
        hired_id: "",
        date: dateNep || "",
        emp_salary: "",
        yearr: YearName || "",
        monthh: "",
        branch: 1 || "",
        designation: "",
        basic_sal: "",
        grade_count: "",
        grade_amount: "",
        basic_tot_amount: "",
        pf: "",
        pf_thap: "",
        thap: "",
        abs_day: "",
        att_day: "",
        abs_amt: "",
        other_al: "",
        total_salary: "",
        pf_total: "",
        tax: "",
        sa_su_tax: "",
        other_less_amt: "",
        abs_day_less: "",
        abs_amt_less: "",
        net_salary: "",
        posted_tsn: "",
        remarks: "",
        upadan_thap: "",
        upadan_katti: "",
        post: "",
    };
    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                const value = (values as Record<string, any>)[key];
                if (value !== undefined && value !== null && value !== "") {
                    formData.append(key, value);
                }
            });
            try {
                await postDataToTheServer(AppURL.PayrollURL + 'payroll/staff/payroll/create/list/view/', formData).then((res) => {
                    if (res?.status === 201) {
                        handleFormSuccess();
                        ToastSuccess({ message: res?.message });
                        action.resetForm();
                    } else if (res?.status === 400) {
                        ToastWarning({ message: res?.message });
                    }
                    else {
                        ToastWarning({ message: "Some Issue" });
                    }
                });
            } catch (error) {
                console.log(error);
            }
        },
    });
    const { data: payrollData, loading: payroll_loading, error: payroll_error } = useFetchSubData(
        `${AppURL.PayrollURL}payroll/details/report/list/view/?monthh=${values.monthh}&yearr=${values.yearr}`,
        values.monthh && values.yearr
    );

    useEffect(() => {
        if (!payroll_loading && payrollData) {
            dispatch(STAFF_PAYROLL_LIST(payrollData.data));
        }
    }, [payrollData, payroll_loading, dispatch]);

    if (payroll_loading) {
        return <div>Loading...</div>;
    }

    if (payroll_error) {
        return <div>Error: {payroll_error.message}</div>;
    }
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <Grid container columnSpacing={1} rowSpacing={0.8}>
                    <Grid item xl={2} lg={2} sm={6} md={2} xs={12}>
                        <InputTextBox
                            type='text'
                            name='date'
                            label='Date(BS)'
                            handleChange={handleChange}
                            value={values.date}
                            error={typeof errors.date === 'string' ? errors.date : undefined}
                            handleBlur={handleBlur}
                            touched={!!touched.date}
                            required={true}
                            disabled
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={2} xs={12}>
                        <SelectInputBox
                            label="Staff"
                            options={employeeOptions}
                            name='emp_salary'
                            required={true}
                            placeholder='Select Employee'
                            optionSelect={(name, selectedOption) => {
                                setFieldValue("hired_id", selectedOption.value || "1");
                                setFieldValue("emp_salary_id", selectedOption.value || "1");
                                setFieldValue("designation", selectedOption.designation || "1");
                                setFieldValue("basic_sal", selectedOption.basic_sal || "0");
                                setFieldValue("grade_count", selectedOption.grade_count || "0");
                                setFieldValue("grade_amount", selectedOption.grade_amount || "0");
                                setFieldValue("basic_tot_amount", selectedOption.basic_tot_amount || "0");
                                setFieldValue("pf", selectedOption.pf || "0");
                                setFieldValue("pf_thap", selectedOption.pf_thap || "0");
                                setFieldValue("pf_total", selectedOption.pf_total || "0");
                                setFieldValue("thap", selectedOption.thap || "0");
                                setFieldValue("abs_day", selectedOption.abs_day || "0");
                                setFieldValue("att_day", selectedOption.att_day || "0");
                                setFieldValue("abs_amt", selectedOption.abs_amt || "0");
                                setFieldValue("other_al", selectedOption.other_al || "0");
                                setFieldValue("total_salary", selectedOption.total_salary || "0");
                                setFieldValue("tax", selectedOption.tax || "0");
                                setFieldValue("sa_su_tax", selectedOption.sa_su_tax || "0");
                                setFieldValue("other_less_amt", "0");
                                setFieldValue("abs_day_less", selectedOption.abs_day_less || "0");
                                setFieldValue("abs_amt_less", selectedOption.abs_amt_less || "0");
                                setFieldValue("net_salary", selectedOption.net_salary || "0");
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.emp_salary}
                            touched={touched.emp_salary}
                        />
                    </Grid>

                    <Grid item xl={2} lg={2} sm={6} md={2} xs={12}>
                        <InputTextBox
                            type='text'
                            name='yearr'
                            label='Year(BS)'
                            handleChange={handleChange}
                            value={values.yearr}
                            error={typeof errors.yearr === 'string' ? errors.yearr : undefined}
                            handleBlur={handleBlur}
                            touched={!!touched.yearr}
                            required={true}
                        />
                    </Grid>
                    <Grid item xl={2} lg={2} sm={6} md={2} xs={12}>
                        <SelectInputBox
                            label="Month"
                            options={NepaliMonthOptions}
                            name='monthh'
                            required={true}
                            placeholder='Select month Name'
                            optionSelect={(name, selectedOption) => {
                                handleSelectBox({ setFieldValue, name, value: selectedOption })
                            }
                            }
                            value={values.monthh}
                            touched={touched.monthh}
                        />
                    </Grid>
                    <Grid item xl={4} lg={4} sm={12} md={4} xs={12}>
                        <EndBaseLine top={18}>
                            <Button btn_type='save' type='submit' el='button' />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>

        </Container>
    )
}

export default PayrollCreateFormView